<template>
    <select
        class="ds-select"
        :class="{ 'ds-select--invalid': invalid }"
        :value="value"
        :disabled="disabled"
        @change="$emit('change', $event)"
    >
        <option v-for="o in options" :key="o.value" :value="o.value">{{ o.label }}</option>
    </select>
</template>

<script>
export default {
    name: 'DsSelect',
    props: {
        options: { type: Array, default: () => [] },
        value: { type: [String, Number], default: '' },
        invalid: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
.ds-select {
    width: 100%;
    height: var(--control-height);
    padding: 0 32px 0 var(--space-3);
    font: var(--type-body);
    color: var(--text-body);
    background: var(--surface-card);
    border: var(--border-width) solid var(--border-field);
    border-radius: var(--radius-sm);
    outline: none;
    transition: var(--transition-control);
    box-sizing: border-box;
    appearance: none;
    background-image: linear-gradient(45deg, transparent 50%, var(--text-muted) 50%), linear-gradient(135deg, var(--text-muted) 50%, transparent 50%);
    background-position: calc(100% - 18px) 15px, calc(100% - 12px) 15px;
    background-size: 6px 6px, 6px 6px;
    background-repeat: no-repeat;
}
.ds-select:focus { border-color: var(--brand-blue); box-shadow: var(--shadow-focus); }
.ds-select--invalid { border-color: var(--danger); }
</style>
